/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-16 21:10:13
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-22 10:17:14
 */
export default {
	"menu.home": "主页",
	"menu.account": "广告账户",
	"menu.automatedRules": "自动化规则",
	"menu.automatedRules.manageRules": "规则管理",
	"menu.automatedRules.rulesMarket": "规则市场",
	"menu.automatedRules.actionHistory": "运行历史",
	"menu.adManagement": "广告管理",
	"menu.adManagement.create": "广告创建",
	"menu.adManagement.copy.adgroup": "复制广告组",
	"menu.adManagement.copy.campaign": "复制广告系列",

	"menu.adManagement.runLog": "运行日志",
	"menu.assetOperation": "资产操作",
	"menu.assetOperation.materialDuplication": "素材复制",
	"menu.assetOperation.bindingOfSparkAds": "Spark Ads绑定",
	"menu.logout": "退出登录",
	"menu.logout.confirm.content": "您确定要退出吗？"
};
